import React, { Component } from "react"
import { browserHistory, Link } from "react-router-dom"
import { Breadcrumb, Icon } from "semantic-ui-react"
import { observer } from "mobx-react"
import shop from "shop/shop"
import categoryStore from "stores/categoryStore"

@observer
class CollectionBreadcrumb extends Component {

  render() {
    let category = categoryStore.categoriesById.get(this.props.id)
    console.log("Rendering ", categoryTitle, "with path:", path, this.props.id, this.props)

    if (!category) return <div>      <Breadcrumb>
      <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
      {<Breadcrumb.Divider />}
      <Breadcrumb.Section active style={{ whiteSpace: "nowrap" }}>{this.props.id ? this.props.id : "Keine Kategorie"}</Breadcrumb.Section>
    </Breadcrumb></div>

    let path = shop.getCategoryPath(this.props.id)
    let categoryTitle = ""
    if (category && category.desc) categoryTitle = category.desc.short_des

    return (<div className="">
      <Breadcrumb>
        <Breadcrumb.Section link as={Link} to="/" style={{ padding: "10px" }}><Icon name="home" /></Breadcrumb.Section>
        <Breadcrumb.Divider icon="right chevron" />
        {path.length > 1 &&
          <Breadcrumb.Section link as={Link} style={{ whiteSpace: "nowrap", padding: "10px" }} to={path[0].link}
            className="parent-title">{path[0].title}</Breadcrumb.Section>}
        {path.length > 1 && <Breadcrumb.Divider />}
        <Breadcrumb.Section active style={{ whiteSpace: "nowrap", padding: "10px" }}>{categoryTitle}</Breadcrumb.Section>
      </Breadcrumb>
    </div>)
  }

}


export default CollectionBreadcrumb


// WEBPACK FOOTER //
// ./src/theme/mags/components/Collection/CollectionBreadcrumb.js